document.querySelectorAll("form [required]").forEach(requiredElement => {
	requiredElement.parentElement.classList.add("required");
});
